import { Link } from 'react-router-dom';
import { AdminFeedbackSession } from '../../types/types';
import { formatDate } from '../../utils/utils';

interface FeedbackSessionRowProps {
  feedbackSession: AdminFeedbackSession;
}

export const FeedbackSessionRow = ({ feedbackSession }: FeedbackSessionRowProps) => {
  const linkTo = `/admin/feedback/${feedbackSession.feedback_session_id}`;
  const linkClassName = 'block w-full h-full cursor-pointer';

  const cellData = [
    feedbackSession.feedback_session_id,
    feedbackSession.note_id,
    feedbackSession.internal_title,
    feedbackSession.user_id,
    feedbackSession.feedback_events.length,
    formatDate(feedbackSession.last_modified),
  ];

  return (
    <tr className={`hover:bg-blue-100`}>
      {cellData.map((content, index) => (
        <td key={index} className="px-4 py-2 border-2 border-gray-400">
          <Link to={linkTo} className={linkClassName}>
            {content}
          </Link>
        </td>
      ))}
    </tr>
  );
};
